import { render, staticRenderFns } from "./promotion.vue?vue&type=template&id=4286f5a6&"
import script from "./promotion.vue?vue&type=script&lang=js&"
export * from "./promotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports